import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCo2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "pollution-co2" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 12,
			cy: 12,
			r: 11.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M9,8.25a3,3,0,0,0-3,3v1.5a3,3,0,0,0,3,3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M12.75,8.25a1.5,1.5,0,0,0-1.5,1.5v4.5a1.5,1.5,0,0,0,3,0V9.75A1.5,1.5,0,0,0,12.75,8.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M16.5,13.875a1.125,1.125,0,0,1,1.125-1.125h0a1.125,1.125,0,0,1,1.125,1.125h0a1.608,1.608,0,0,1-.351,1L16.5,17.25h2.25"
		})
	]
});
export default SvgCo2;
